import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    destroyOnComplete: true,
    transforms: [
      // Initial transform
      {
        alpha: 1,
        x: convertToPercentageX(91),
        y: convertToPercentageY(186 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        wait: 1500,
        callback: () => {
          G.sfx.exchange.play();
        },
      },
      {
        x: convertToPercentageX(270),
        y: convertToPercentageY(133 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(450),
        y: convertToPercentageY(186 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(718),
        y: convertToPercentageY(136 + yOffset),
        duration: 400,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    transforms: [
      {
        alpha: 0,
        angle: -71,
        x: convertToPercentageX(326),
        y: convertToPercentageY(791),
        scale: 2.88,
      },
      {
        alpha: 1,
        angle: -119,
        x: convertToPercentageX(332),
        y: convertToPercentageY(605),
        scale: 3.6,
        duration: 165,
      },
      {
        angle: -148,
        x: convertToPercentageX(336),
        y: convertToPercentageY(496),
        scale: 4,
        duration: 100,
      },
      {
        angle: -176,
        x: convertToPercentageX(332),
        y: convertToPercentageY(321),
        scale: 3.74,
        duration: 135,
      },
      {
        alpha: 0,
        angle: -120,
        x: convertToPercentageX(326),
        y: convertToPercentageY(53),
        scale: 3.23,
        duration: 200,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(115),
        y: convertToPercentageY(844),
      },
      {
        wait: 2100 - 1710,
      },
      {
        alpha: 1,
        angle: 40,
        x: convertToPercentageX(117),
        y: convertToPercentageY(651),
        scale: 1.18,
        duration: 135,
      },
      {
        angle: 85,
        x: convertToPercentageX(120),
        y: convertToPercentageY(431),
        scale: 1.38,
        duration: 165,
      },
      {
        alpha: 0,
        angle: 160,
        x: convertToPercentageX(125),
        y: convertToPercentageY(66),
        scale: 1.73,
        duration: 270,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('hard_corruption'),
    destroyOnComplete: true,
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(529),
        y: convertToPercentageY(566),
      },
      {
        wait: 2100 - 1710,
      },
      {
        alpha: 1,
        angle: 43,
        x: convertToPercentageX(524),
        y: convertToPercentageY(457),
        scale: 1.16,
        duration: 130,
      },
      {
        angle: 105,
        x: convertToPercentageX(516),
        y: convertToPercentageY(302),
        scale: 1.39,
        duration: 200,
      },
      {
        alpha: 0,
        angle: 175,
        x: convertToPercentageX(507),
        y: convertToPercentageY(126),
        scale: 1.65,
        duration: 235,
      },
    ],
  },
];
